import React from "react";
import BreakpointVisibilityOrg from "../../organisms/BreakpointVisibilityOrg";
import DesktopProductBoxMol from "./DesktopProductBoxMol";
import MobileProductBoxMol from "./MobileProductBoxMol";
function HorizontalProductBoxMol(_ref) {
  var items = _ref.items,
    promotionText = _ref.promotionText,
    renewalPrice = _ref.renewalPrice;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
    from: "small",
    to: "large"
  }, /*#__PURE__*/React.createElement(MobileProductBoxMol, {
    items: items,
    promotionText: promotionText,
    renewalPrice: renewalPrice
  })), /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
    from: "large"
  }, /*#__PURE__*/React.createElement(DesktopProductBoxMol, {
    items: items,
    promotionText: promotionText,
    renewalPrice: renewalPrice
  })));
}
export default HorizontalProductBoxMol;